export const GET_TOTAL_STATS = 'NOV/get_total_stats';
export const GET_GRAPH_STATS = 'NOV/get_graph_stats';

export const LEGENDS = [
    { name: 'VIOLATIONS', color: '#A3B3F9', value: 0 },
];
